import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../../../../../components/Modal';
import Steps from '../../../../../components/Steps';
import FirstStep from './FirstStep';
import SecondStep from './SecondStep';
import ThirdStep from './ThirdStep';
import { FadeLoader } from 'react-spinners';
import Alert from '../../../../../components/Alert';
import { fetchEquiposAdicionales, fetchColaboradores, clearColaboradores, grabarEquiposAdicionales,
  fetchProveedorEquposAdicionales,fetchProformas,fetchFacturacion} from '../../../../../actions';
import getTipoEquipos from '../../../../../utils/getTipoEquipos';
import getPedidosFechas from '../../../../../utils/getPedidosFechas';
import _ from 'lodash';

const vacio='';
const paginaEquiposAdicionales=1;
const cantidadxPaginaEquiposAdicionales=3;
const tipoEquipoEquiposAdicionales=1;
const estadoInactividad= 'S';
const tipoCorreo = 2;
const ESTADO_PEDIDO_ASIGNADO = 'ASIGNADO';
const TIPO_CONSULTA_AGRUPADO_X_FACTURACION_LISTADO_TOTAL='0';
const CON_PAGINACION='N';
const VACIO='';


class AgregarEquiposAdicionales extends Component {

  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      equiposProveedor: [],
      equiposProveedorSeleccionado: [],
      divProveedores:'none',
      divEquiposAdicionales:'block',
      inputSearchProviderOrEquipment:1,
      colaboradoresSeleccionados: [],
      colaborador:'',
      tipoAdicionalSelect:'',
      observacionEquipoAdicionales:'',
      inputSearchEquipoLogistica:'',
      muestraLoad: 'none',
      alertWarnnigOpen:false,
      tipoAdicional:[],
      numeroPaginas:0,
      numeroRegistros:0,
      clientInput:'',
      nomPerso:'',
      pedidosEquiposAdicionales:[],
      proformaSeleccionadaTabEquipoLogistica : {},
      tipoLlamadaEquiposAdicionales:'0',
      nurPedidos:[],
      mensaje:'',

    };
  }

  componentDidMount() {
    this.openEquipoAdicionales(this.props.proforma,this.props.proforma.numFichaVtaVeh);
  }

  nextStep = () => this.setState({ step: this.state.step + 1})
  previousStep = () => this.setState({ step: this.state.step - 1})

  searchProveedorEquiposAdicionales = (inputSearchProviderOrEquipment) =>{



      if(this.state.inputSearchProviderOrEquipment === 0){
        this.setState({ muestraLoad: 'block' });
        this.props.fetchProveedorEquposAdicionales(vacio,this.state.clientInput,1);
        this.setState({ muestraLoad: 'none' });

      }else if(this.state.inputSearchProviderOrEquipment === 1){
        this.setState({ muestraLoad: 'block' });

        this.fnSeleccionProveedorEquiposLogistica(vacio, vacio,inputSearchProviderOrEquipment===undefined?this.state.tipoAdicionalSelect:inputSearchProviderOrEquipment,this.state.clientInput,vacio);
      }else if(this.state.inputSearchProviderOrEquipment === 3){
        this.setState({ muestraLoad: 'block' });
        this.fnSeleccionProveedorEquiposLogistica(vacio, vacio,inputSearchProviderOrEquipment===undefined?this.state.tipoAdicionalSelect:inputSearchProviderOrEquipment,vacio,this.state.clientInput);

      }else if(this.state.inputSearchProviderOrEquipment === 2){
        this.setState({ muestraLoad: 'block' });
        this.props.fetchProveedorEquposAdicionales(this.state.clientInput,vacio,1);
        this.setState({ muestraLoad: 'none' });
      }


  }

  removeColaborador = (id) => {
    const { colaboradoresSeleccionados } = this.state;
    this.setState({ colaboradoresSeleccionados: colaboradoresSeleccionados.filter(colaborador => id !== colaborador.id) });
  }


  fnSeleccionProveedor =(codProv,nomPerso) =>{

      console.log(this.state.inputSearchProviderOrEquipment);

      if(this.state.inputSearchProviderOrEquipment === 0){

        this.fnSeleccionProveedorEquiposLogistica(codProv, vacio,this.state.tipoAdicionalSelect,vacio,vacio);
        this.setState({divProveedores:'block',divEquiposAdicionales:'none',inputSearchProviderOrEquipment:0,clientInput:'',nomPerso:nomPerso});
      }else if(this.state.inputSearchProviderOrEquipment === 2){
        this.fnSeleccionProveedorEquiposLogistica(codProv, vacio,this.state.tipoAdicionalSelect,vacio,vacio);
        this.setState({divProveedores:'block',divEquiposAdicionales:'none',inputSearchProviderOrEquipment:2,clientInput:'',nomPerso:nomPerso});
      }

  }

    onClickRetornar = () =>{
      this.setState({divProveedores:'block',divEquiposAdicionales:'none',inputSearchProviderOrEquipment:0,clientInput:'',nomPerso:''});

    }

    fnSeleccionProveedorEquiposLogistica = (codProv, nomPerso,subTipoEquipo,descEquipo,codEquipo) => {

      this.setState({ muestraLoad: 'block' });

        this.props.fetchEquiposAdicionales(
          this.props.proforma.codAreaVta,
          this.props.proforma.codBaumuster,
          this.props.fdv.codCia,
          codEquipo,
          this.props.proforma.codFamiliaVeh,
          this.props.proforma.codMarca,
          codProv,
          descEquipo,
          subTipoEquipo,
          1,
          tipoEquipoEquiposAdicionales,
          this.props.proforma.tipoMoneda,
          paginaEquiposAdicionales,
          cantidadxPaginaEquiposAdicionales
        ).then((result) => {
          this.setState({ equiposProveedor: result.payload.data.equipoAdicionalLocalList,
            numeroPaginas: result.payload.data.cantidad,
            numeroRegistros:result.payload.data.numerodePaginas,
            muestraLoad: 'none' });
        }).catch((error) => {
          console.log(error);

        });

    }


  adicionRestasEquiposAdicionales = (codEquipo,tipoOperacion,tipoPestaña)=>{

    let equipoProveedor = {};
    if(tipoPestaña===2){
      equipoProveedor = this.state.equiposProveedor.filter(equipo => equipo.codEquipo===codEquipo)[0];
    }else if(tipoPestaña===3){
      equipoProveedor = this.state.equiposProveedorSeleccionado.filter(equipo => equipo.codEquipo===codEquipo)[0];
    }
    if(tipoOperacion===1){equipoProveedor.cantidad++}else if(equipoProveedor.cantidad>0){equipoProveedor.cantidad--};

    if(this.state.equiposProveedorSeleccionado.length===0){
      this.setState({equiposProveedorSeleccionado:[...this.state.equiposProveedorSeleccionado,equipoProveedor]});
    }else{
      this.setState({equiposProveedorSeleccionado:[...this.state.equiposProveedorSeleccionado.filter(equipo => equipo.codEquipo!==codEquipo),equipoProveedor]});
    }

  }

  eliminateAdditionalEquipment = (codEquipo)=>{

    let equiposProveedor = this.state.equiposProveedor.filter(equipo => equipo.codEquipo===codEquipo)[0];

    equiposProveedor.cantidad=0;
    this.setState({equiposProveedor:[...this.state.equiposProveedor.filter(equipo => equipo.codEquipo!==codEquipo),equiposProveedor]});
    this.setState({equiposProveedorSeleccionado:this.state.equiposProveedorSeleccionado.filter(equipo => equipo.codEquipo!==codEquipo)});
  }

  typeSearch = (e) =>{

    if(e.target.value==='proveedor'){
      this.setState({divProveedores:'block',divEquiposAdicionales:'none',inputSearchProviderOrEquipment:0,clientInput:''});
      this.props.fetchProveedorEquposAdicionales(vacio,vacio,1);

    }else if(e.target.value==='equipo'){
      this.setState({divProveedores:'none',divEquiposAdicionales:'block',inputSearchProviderOrEquipment:1,clientInput:''});
      this.fnSeleccionProveedorEquiposLogistica(vacio, vacio,this.state.tipoAdicionalSelect,this.state.clientInput,vacio);
    }else if(e.target.value==='codequipo'){
      this.setState({divProveedores:'none',divEquiposAdicionales:'block',inputSearchProviderOrEquipment:3,clientInput:''});
      this.fnSeleccionProveedorEquiposLogistica(vacio, vacio,this.state.tipoAdicionalSelect,vacio,this.state.clientInput,);
    }else if(e.target.value === 'codproveedor'){
      this.setState({divProveedores:'block',divEquiposAdicionales:'none',inputSearchProviderOrEquipment:2,clientInput:''});
      this.props.fetchProveedorEquposAdicionales(vacio,vacio,1);

    }
  }



  changeColaborador = (e) => {
    this.onChangeValueThird(e);
    if (e.target.value.length >= 2) {
      this.props.fetchColaboradores(e.target.value);
    } else if (e.target.value.length === 0) {
      this.props.clearColaboradores();
    }
  }

  onChangeValueThird = e => {
      this.setState({[e.target.name]: e.target.value });
  }

  onChangeValue = e => {
      this.setState({[e.target.name]: e.target.value });
      if(this.state.inputSearchProviderOrEquipment === 1){
        this.setState({ divEquiposAdicionales:'block'})
      }
      this.searchProveedorEquiposAdicionales(e.target.value );
  }


  onChangeInput = e =>{
    this.setState({   [e.target.name]: e.target.value })
  }

  selectColaborador = (key) => {
    const colaboradorSelected = this.state.colaboradoresSeleccionados.filter(colaborador => colaborador.id === key).length;

    if (!colaboradorSelected) {
      const nombres = this.props.colaboradores
        .filter(({ idUsuario }) => idUsuario.toString() === key)[0].nombre;
      const apellidos = this.props.colaboradores
        .filter(({ idUsuario }) => idUsuario.toString() === key)[0].apellidos;
      const colaborador = { id: key, nombres: `${apellidos} ${nombres}` };
      this.setState({ colaborador: '', colaboradoresSeleccionados: [...this.state.colaboradoresSeleccionados, colaborador] });
      this.props.clearColaboradores();
    }
  }

  handlePageClick = ({ selected }) => {
    this.setState({ muestraLoad: 'block' });

    this.props.fetchEquiposAdicionales(
      this.props.proforma.codAreaVta,
      this.props.proforma.codBaumuster,
      this.props.fdv.codCia,
      vacio,
      this.props.proforma.codFamiliaVeh,
      this.props.proforma.codMarca,
      vacio,
      this.state.inputSearchEquipoLogistica,
      vacio,
      this.props.fdv.valTipoCambioFichaVta!==null?this.props.fdv.valTipoCambioFichaVta:1,
      tipoEquipoEquiposAdicionales,
      this.props.proforma.tipoMoneda,
      selected!==undefined ?selected+1:1,
      cantidadxPaginaEquiposAdicionales
    ).then((result) => {
      this.setState({ equiposProveedor: result.payload.data.equipoAdicionalLocalList });

      this.setState({ muestraLoad: 'none' });
    }).catch((error) => {
      console.log(error);
    });

  }

  guardarAplicarAdicionales = () =>{

    if(this.state.tipoAdicionalSelect===''){
        this.showAlert('alertWarnnigOpen','Seleccione el tipo de adicional.');
    }else if(this.state.equiposProveedorSeleccionado.length === 0){
        this.showAlert('alertWarnnigOpen','Seleccione al menos un equipo adicional.');
    }else{



      console.log('pedidosEquiposAdicionales',this.state.pedidosEquiposAdicionales);

      console.log('equiposProveedorSeleccionado',this.state.equiposProveedorSeleccionado);



      this.setState({ muestraLoad: 'block' });
      const promises = [];
          promises.push(
          this.state.pedidosEquiposAdicionales.forEach(pedido => {
            this.state.equiposProveedorSeleccionado.forEach(equipo => {



                this.props.grabarEquiposAdicionales(
                  this.props.fdv.numFichaVtaVeh,
                  this.state.colaboradoresSeleccionados.map(function(entry) {return entry.id}),
                  this.props.fdv.numFichaVtaVeh,
                  equipo.codEquipo,
                  equipo.codMonedaEquipoLocal,
                  this.state.tipoAdicionalSelect,
                  this.state.observacionEquipoAdicionales,
                  estadoInactividad,
                  equipo.cantidad,
                  this.props.fdv.numFichaVtaVeh,
                  this.state.nurPedidos.filter(entry => entry.numPedidoVeh===pedido)[0].nurFichaVtaPedido,
                  tipoCorreo,
                  equipo.precio,
                  equipo.precio*equipo.cantidad,
                  pedido,
                  equipo.descEquipo
                )
            })

          }))

          Promise.all(promises).then((results) => {

                  this.props.openAlert({estadoTrama:'1',mensaje:'Se Ejecuto Correctamente'})
                  this.props.closeModal();
                  this.setState({ muestraLoad: '' });
            }).catch((error) => {
                  this.setState({ muestraLoad: '' });
                  this.props.openAlert({estadoTrama:'0',mensaje:'No se Ejecuto Correctamente'})
                  this.props.closeModal();
             });

     }

     /*if(this.props.whereRunTabOrProf!=='1'){
           this.props.fnUnSelectedAll();
     }*/

  }

  openEquipoAdicionales = (proforma, id) => {

    this.props.loading('block');
    this.props.fetchColaboradores('');
    this.handlePageClick('');

    getTipoEquipos(this.props.fdv.codAreaVta).then((result)=>{
      this.setState({tipoAdicional:result.data.itemList});
    })

    this.props.fetchFacturacion(id, TIPO_CONSULTA_AGRUPADO_X_FACTURACION_LISTADO_TOTAL, CON_PAGINACION, VACIO, VACIO)
    .then(pedidos => {

        this.setState({nurPedidos:pedidos.payload.data.listado})

          this.props.fetchProformas(id).then((entry) => {

            const idsProformas = entry.payload.data.proformaExistenteList.map(row => row.numProfVeh);

            getPedidosFechas(id, idsProformas).then((result) => {

              let pedido =  _.filter(result, _.property(proforma.numProfVeh))[0][proforma.numProfVeh];
              let statusPedido = pedido.filter(entry => pedidos.payload.data.listado.map(facturacionPedido => {return facturacionPedido.numPedidoVeh}).indexOf(entry.numPedidoVeh)>=0);

              let pedidosNoCumpleCondicion = this.props.pedidosConCheck===undefined?[]:this.props.pedidosConCheck.filter(pedidosConCheck => !statusPedido.map(function(entry) {return entry.numPedidoVeh}).indexOf(pedidosConCheck)>=0) ;
              let pedidosCumplenCondicion = this.props.pedidosConCheck===undefined?statusPedido.map(function(entry) {return entry.numPedidoVeh}):this.props.pedidosConCheck;

              this.setState({
                proformaSeleccionadaTabEquipoLogistica:proforma,
                tipoLlamadaEquiposAdicionales:this.props.tipoLlamadaEquiposAdicionales===undefined?'1':this.props.tipoLlamadaEquiposAdicionales,
                pedidosEquiposAdicionales: pedidosCumplenCondicion
              });


              this.props.loading('');

            });
          })
    })

  }


 eliminarEquiposAdicionales = (numPedidoVeh) => {
    this.setState({ pedidosEquiposAdicionales: this.state.pedidosEquiposAdicionales.filter(entry => entry!==numPedidoVeh)})
  }

 showAlert = (alertType,mensaje) => {
    this.setState({ [alertType]: true });
    setTimeout(() => this.setState({ [alertType]: false }), 5000);
    this.setState({mensaje:mensaje})
  }

closeAlert = () => this.setState({ alertWarnnigOpen: false });

handlePageClickEquiposEspeciales = ({ selected }) => {
  this.props.fetchProveedorEquposAdicionales('', this.state.valueSerach, selected + 1);
}


  render() {
    const { step } = this.state;
    const stepsTitle = ['Confirmar pedidos', 'Seleccionar equipos', 'Confirmar'];

    return (
      <div>
          <Modal title='Agregar equipos' idModal='agregar-equipos' isOpen closeModal={this.props.closeModal} modalSize='modal-dialog modal-lg'>
            <div className='modalBleed'>
              <Steps stepsTitle={stepsTitle} step={step} />
            </div>
            <div className='fdvEquip-slides'>
              {
                step === 1 &&
                <FirstStep
                  nextStep={this.nextStep}
                  pedidosEquiposAdicionales={this.state.pedidosEquiposAdicionales}
                  eliminarEquiposAdicionales={this.eliminarEquiposAdicionales}
                  equiposProveedor={this.props.equiposProveedor}
                  tipoLlamadaEquiposAdicionales={this.state.tipoLlamadaEquiposAdicionales}
                />
              }
              {
                step === 2 &&
                <SecondStep
                  nextStep={this.nextStep}
                  previousStep={this.previousStep}
                  pedidosEquiposAdicionales={this.state.pedidosEquiposAdicionales}
                  eliminarEquiposAdicionales={this.eliminarEquiposAdicionales}
                  proveedorEquposAdicionales={this.props.proveedorEquposAdicionales}
                  search={this.props.search}
                  clientInput={this.state.clientInput}
                  onChangeInput={this.onChangeInput}
                  tipoAdicional={this.state.tipoAdicional}
                  handlePageClickEquiposEspeciales={this.handlePageClickEquiposEspeciales}
                  searchProveedorEquiposAdicionales={this.searchProveedorEquiposAdicionales}
                  proveedorEquipoLogistica={this.props.proveedorEquipoLogistica}
                  nomPerso={this.state.nomPerso}
                  equiposProveedor={this.state.equiposProveedor}
                  fnSeleccionProveedor={this.fnSeleccionProveedor}
                  adicionRestasEquiposAdicionales={this.adicionRestasEquiposAdicionales}
                  eliminateAdditionalEquipment={this.eliminateAdditionalEquipment}
                  equiposLogistica={this.props.equiposLogistica}
                  equiposProveedorSeleccionado={this.state.equiposProveedorSeleccionado}
                  typeSearch={this.typeSearch}
                  divProveedores={this.state.divProveedores}
                  divEquiposAdicionales={this.state.divEquiposAdicionales}
                  handlePageClick={this.handlePageClick}
                  inputSearchProviderOrEquipment={this.state.inputSearchProviderOrEquipment}
                  onChangeValue={this.onChangeValue}
                  muestraLoad={this.state.muestraLoad}
                  numeroPaginas={this.state.numeroPaginas}
                  onClickRetornar = {this.onClickRetornar}
                />
              }
              {
                step === 3 &&
                <ThirdStep
                  previousStep={this.previousStep}
                  equiposProveedor={this.state.equiposProveedor}
                  adicionRestasEquiposAdicionales={this.adicionRestasEquiposAdicionales}
                  equiposProveedorSeleccionado={this.state.equiposProveedorSeleccionado}
                  divProveedores={this.state.divProveedores}
                  divEquiposAdicionales={this.state.divEquiposAdicionales}
                  eliminateAdditionalEquipment={this.eliminateAdditionalEquipment}
                  pedidosEquiposAdicionales={this.state.pedidosEquiposAdicionales}
                  colaboradoresSeleccionados={this.state.colaboradoresSeleccionados}
                  changeColaborador={this.changeColaborador}
                  selectColaborador={this.selectColaborador}
                  colaborador={this.state.colaborador}
                  colaboradores={this.props.colaboradores}
                  guardarAplicarAdicionales={this.guardarAplicarAdicionales}
                  onChangeValue={this.onChangeValue}
                  muestraLoad={this.state.muestraLoad}
                  observacionEquipoAdicionales={this.state.observacionEquipoAdicionales}
                  removeColaborador={this.removeColaborador}
                  onChangeInput={this.onChangeInput}
                />
              }
            </div>
            <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ display: this.state.muestraLoad }} >
              <div className='modal-dialog modal-sm' role='document'>
                <FadeLoader color={'#F8A14A'} loading />
              </div>
            </div>
          </Modal>

          {this.state.alertWarnnigOpen &&
                <Alert type='alert-warning alertModal' icon='ion-alert-circled' closeAlert={this.closeAlert}>
                    <p>{this.state.mensaje}</p>
                </Alert>
          }

          {
            this.props.equiposLogistica && this.props.equiposLogistica.error ?
              <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                <p>Hubo un error con el servicio de listar equiposLogistica</p>
              </Alert> : null
          }

          {
            this.props.colaboradores && this.props.colaboradores.error ?
              <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                <p>Hubo un error con el servicio de listar colaboradores</p>
              </Alert> : null
          }

          {
            this.props.proveedorEquposAdicionales && this.props.proveedorEquposAdicionales.error ?
              <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
                <p>Hubo un error con el servicio de listar proveedorEquposAdicionales</p>
              </Alert> : null
          }
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    equiposLogistica: state.equiposLogistica,
    colaboradores : state.colaboradores,
    proveedorEquposAdicionales: state.proveedorEquposAdicionales,

  };
}

export default connect(
  mapStateToProps,
  { fetchEquiposAdicionales, fetchColaboradores, clearColaboradores, grabarEquiposAdicionales,fetchProveedorEquposAdicionales,fetchProformas,fetchFacturacion }

)(AgregarEquiposAdicionales);



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/EquiposLogistica/AgregarEquiposAdicionales/index.js